import React from "react";
import { FluentBadge } from "../FluentUI/Fluent-Badge";
import "./priority-fluent-new.scss";

const PriorityFluentNew = ({ priority }) => {
return (
    <div className={`${priority} new-fluent-priority`} style={{ pointerEvents: 'none' }}>
      <FluentBadge
        shape="rounded"
        appearance="tint"
        size="extra-large"
        text={priority?.charAt(0)?.toUpperCase()}
      ></FluentBadge>
    </div>
  );
};

export default PriorityFluentNew;